<template>
  <v-container class="terms-and-conditions-container mb-16">
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
        <v-row no-gutters>
          <h1>Old Mutual Will competition rules</h1>
        </v-row>
        <v-row class="mt-12" no-gutters>
          <h2>How to enter</h2>
        </v-row>
        <p class="mt-4">
          1. <span style="text-decoration: underline">Simply login</span> to the
          Old Mutual website at
          <a href="https://www.oldmutualwill.co.za/" target="_blank"
            >www.oldmutualwill.co.za</a
          >
        </p>
        <p>
          2.
          <span style="text-decoration: underline"
            >Create your will online</span
          >
          with Old Mutual; and
        </p>
        <p>
          3. Download your completed will
          <span style="text-decoration: underline">after signing up</span>
        </p>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
        <v-row no-gutters>
          <h2>Terms and Conditions</h2>
        </v-row>
        <p class="mt-4">
          4. By entering this competition, you agree and are deemed to have
          accepted and be bound to all the competition rules as interpreted by
          the organisers.
        </p>
        <p>
          5. The organisers reserve the right to amend, modify or change these
          terms and conditions in their sole and absolute discretion without
          notice. These changes will take effect from the date of publication on
          the website. By participating or continuing to participate in the
          competition, the contestant agrees and understands that he/she will be
          bound by the amended terms and conditions.
        </p>
        <p>
          6. Old Mutual together with Kfm, 94.7& East Coast Radio are the
          promoters of the competition (collectively referred to as the
          “organisers”).
        </p>
        <p>
          7. To be eligible for any prize, you must have opted into the
          competition and create and download your will on Old Mutual's website
          at www.oldmutualwill.co.za
          <span style="text-decoration: underline">after signing up</span>.
        </p>
        <p>
          8. The competition runs from 20 March - 1 April 2024 and winners will
          be announced on the 3rd of April 2024 on Kfm, 94.7 & East Coast Radio.
        </p>
        <p>
          9. Only one valid completed will per person is permitted and
          considered as an entry.
        </p>
        <p>
          10. Old Mutual will randomly select three winners for the duration of
          the competition, in a random lucky draw. Winners will be contacted
          directly.
        </p>
        <p>
          11. The competition organisers (Old Mutual)will notify each winner via
          telephone or email. The competition organisers will use their
          reasonable efforts to contact the winner. If the competition
          organisers are unable to reach a prize winner within 1st hour after
          the announcement has been made, that person will forfeit the prize and
          the organisers reserve the right to then award the prize to the next
          winner via a random draw.
        </p>
        <p>
          12. All contestants' entries and personal information provided will be
          kept confidential, and will only be used for the purposes of the prize
          draw and notification of the winners of this competition. By entering
          into the competition, the contestants consent to the personal
          information of the respective contestant being shared with the
          organisers' service providers for purposes of the competition. This
          data will not be provided to third parties for marketing purposes, and
          will be safegaured and destroyed in compliance with the Protection of
          Personal Informantion Act.
        </p>
        <p>13. The organisers' decision is final.</p>
        <p>
          14. The prize is a R50 000 holiday cash prize per winner paid into the
          winner's bank account.
        </p>
        <p>
          15. You may only win the competition once and must be at least 18
          years old. You must be a natural person in possession of a valid South
          African identity document and be a permanent resident or citizen of
          the Republic of South Africa.
        </p>
        <p>
          16. This competition is in no way sponsored, endorsed or administered
          by, or associated with any Social Network.
        </p>
        <p>17. Contestants participate entirely at their own risk.</p>
        <p>
          18. The right of admission into this competition lies solely with the
          organisers and is non-negotiable.
        </p>
        <p>
          19. Old Mutual has the right to disqualify you if it believes that:
        </p>
        <p style="margin-left: 20px">
          - you have not complied with these rules or
        </p>
        <p style="margin-left: 20px">
          - you tried to unfairly influence the course of the competition or
        </p>
        <p style="margin-left: 20px">
          - there is suspicion of any irregularities or fraudulent activities.
        </p>
        <p>
          20. All efforts will be made to ensure that winners physically receive
          their prize by Monday the 6th of April.
        </p>
        <p>
          21. The organisers are not responsible for any costs the winner may
          have when claiming or using the prize.
        </p>
        <p>
          22. The organisers of the competition(Old Mutual), the developers and
          any external consultants of Old Mutual Wills and their marketing
          agencies may not participate in the competition or win any prize.
        </p>
        <p>
          23. Old Mutual may terminate this competition with immediate effect.
          In such event, all entrants waive any rights, which they may have
          against Old Mutual, and acknowledge that they will have no recourse to
          any claim of any sort.
        </p>
        <p>
          24. By entering into the competition, the contestant indemnifies and
          holds the organisers, its directors, affiliates, members, partners,
          employees, agents, consultants, suppliers, contractors and sponsors
          harmless against any loss or damages, either direct, indirect,
          consequential or otherwise, arising from its participation in this
          competition and related events and activities, including, without
          limitation, personal injuries, death, and property damage, and claims
          based on publicity rights, defamation or invasion of privacy. Entrants
          accept that the Indemnified Parties will not be responsible for any
          costs, damage or otherwise, howsoever incurred by the winners
          subsequent to claiming the prize.
        </p>
        <p>
          25. The organisers reserve the right to carry out reasonable due
          diligence to confirm eligibility and help ensure that the use of any
          such person in advertising or publicity for the competition will not
          bring the organisers or any of the organisers' brands into public
          disrepute, contempt, scandal or ridicule or reflect unfavourably on
          the competition as determined by the organisers in their sole
          discretion.
        </p>
        <p>
          26. The organisers assume no responsibility whatsoever for any entry
          that has been left out from participation for any reason.
        </p>
        <p>
          27. The prize is not transferable. No substitution or assignment of
          prize is permitted but the organisers of the competition reserve the
          right to substitute the prize with one of comparable value if
          required.
        </p>
        <p>
          28. By entering into the competition, the prize winners agree and
          grant permission to be photographed, filmed, announced on air, and to
          have their names published by Old Mutual and Kfm, 94.7 and East Coast
          Radio on any website, associated radio programme or any other similar
          medium in electronic or printed format. All winners consent to their
          names, photos and relevant video material so published by Old Mutual
          and/or , Kfm, 94.7 and East Coast Radio and agree that they will not
          hold Old Mutual and/or Kfm, 94.7 and East Coast Radio liable in any
          way for these publications in any format whatsoever. The contestants
          are aware that they may access the personal information that Old
          Mutual holds and request Old Mutual to correct any errors or to delete
          this information. The winners may also request Old Mutual and/or Kfm,
          94.7 and East Coast Radio any time to remove their names from any
          website on which personal information is published by Old Mutual
          and/or Kfm, 94.7 and East Coast Radio The organisers will never
          publish any email addresses or any contact telephone numbers of any or
          prize winner. To view our full privacy notice, visit our website on
          www.oldmutual.co.za.
        </p>
        <p>
          29. Old Mutual Life Assurance Company (SA) Limited is a licensed FSP
          and Life Insurer.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'TermsAndConditions',
    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.competitionTermsAndConditions,
          },
        ],
      };
    },
  };
</script>

<style lang="scss">
  .terms-and-conditions-container {
    h1 {
      font-size: 40px;
    }

    h2 {
      font-size: 28px;
    }

    p {
      font-size: 24px;
      a {
        font-size: 24px;
      }
    }
  }
</style>
